import "./ErrorAssignementPage.scss";
import { useTranslation } from "react-i18next";

export default function ErrorPage({ errorType }: { errorType: "not_found" | "expired" }) {
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <img
        src={require(`assets/${
          errorType === "not_found" 
            ? "error_no_data" 
            : "error_sorry"
        }.png`)}
        alt={t("error")}
      />
      <h1>
        {errorType === "not_found"
          ? t("assessment-invitation-not-found")
          : t("assessment-invitation-expired")}
      </h1>
      <h5>
        {errorType === "not_found"
          ? t("no-assessment-invitation-found-please-check-your-link")
          : t("this-assessment-invitation-has-expired-please-contact-your-administrator")}
      </h5>
    </div>
  );
}
